import { MeetingDetails } from '@shared/clientTypes';
import { Stream, VideoClient } from '@zoom/videosdk';
import { RoomEventType } from 'apps/agora/src/views/UserView/VideoMeeting/useMeetingWebsocket';
import { createContext, Dispatch } from 'react';

interface ZoomContextProps {
  zoomClient?: typeof VideoClient;
  meetingDetails?: MeetingDetails;
  activeCamera?: string;
  activeMicrophone?: string;
  isMicrophoneActive: boolean;
  isCameraActive: boolean;
  isMeetingLoading: boolean;
  canJoinMeeting: boolean;
  isZoomClientReady: boolean;
  stream?: typeof Stream;
  webSocket?: WebSocket;
  isSocketConnected: boolean;
  videoSettings: { noiseSuppression?: boolean; virtualBackground?: string };
  setActiveCamera: Dispatch<React.SetStateAction<string | undefined>>;
  setActiveMicrophone: Dispatch<React.SetStateAction<string | undefined>>;
  setIsMicrophoneActive: Dispatch<React.SetStateAction<boolean>>;
  setIsCameraActive: Dispatch<React.SetStateAction<boolean>>;
  setIsMeetingLoading: Dispatch<React.SetStateAction<boolean>>;
  setCanJoinMeeting: Dispatch<React.SetStateAction<boolean>>;
  setIsZoomClientReady: Dispatch<React.SetStateAction<boolean>>;
  setStream: Dispatch<React.SetStateAction<typeof Stream | undefined>>;
  closeWebsocketConnection: () => void;
  sendRoomEvent: (type: RoomEventType, meetingId: string) => Promise<void>;
  logError: (error: any) => void;
}

export const ZoomContext = createContext<ZoomContextProps>({
  isMicrophoneActive: false,
  isCameraActive: false,
  isMeetingLoading: false,
  canJoinMeeting: false,
  isZoomClientReady: false,
  isSocketConnected: false,
  videoSettings: { noiseSuppression: false },
  setActiveCamera: () => console.warn('setActiveCamera implementation needed'),
  setActiveMicrophone: () => console.warn('setActiveMicrophone implementation needed'),
  setIsMicrophoneActive: () => console.warn('setIsMicrophoneActive implementation needed'),
  setIsCameraActive: () => console.warn('setIsCameraActive implementation needed'),
  setIsMeetingLoading: () => console.warn('setIsMeetingLoading implementation needed'),
  setCanJoinMeeting: () => console.warn('setCanJoinMeeting implementation needed'),
  setIsZoomClientReady: () => console.warn('setIsZoomClientReady implementation needed'),
  setStream: () => console.warn('setStream implementation needed'),
  closeWebsocketConnection: () => console.warn('closeWebsocketConnection implementation needed'),
  sendRoomEvent: async () => console.warn('sendRoomEvent implementation needed'),
  logError: () => console.warn('logError implementation needed'),
});
